<!-- MFITTの空席照会で、非対応の区間を選択した場合 -->
<template>
  <ItemDialog ref="invalidSection" image-type="alert">
    <template #content-area>
      <p class="text-center">
        指定された区間（出発駅、到着駅）は、本サービスではご利用できません
      </p>
    </template>
    <template #button-area>
      <ItemButton
        label="閉じる"
        action-type="btn-primary"
        @clicked="closeDialog()"
      />
    </template>
  </ItemDialog>
</template>

<script>
import { ref } from "vue";

export default {
  name: "DialogInvalidSection",
  setup() {
    const invalidSection = ref(null);

    const openDialog = () => {
      invalidSection.value.open();
    };

    const closeDialog = () => {
      invalidSection.value.close();
    };

    return {
      invalidSection,
      openDialog,
      closeDialog,
    };
  },
};
</script>
